import { createContext } from 'react';

import type { AppProviderProps } from './useAppProvider';

export const AppContext = createContext({} as AppProviderProps);
